import { useEffect, useRef, useState } from "react";
import { ArrowUpRight, ChevronDown } from "lucide-react";

export const SignInChooser = ({ buttonClass = "", testidPrefix = "signin" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, []);

  return (
    <div ref={ref} className="relative inline-block">
      <button type="button" data-testid={`${testidPrefix}-button`} onClick={() => setOpen(!open)} className={buttonClass}>
        Sign in <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid={`${testidPrefix}-menu`}
          className="absolute right-0 top-full mt-2 w-72 bg-white border border-line rounded-[14px] shadow-xl z-50 overflow-hidden text-left"
        >
          <a
            data-testid={`${testidPrefix}-cctv`}
            href="https://wsafe.si"
            target="_blank"
            rel="noopener noreferrer"
            className="block px-5 py-4 border-b border-line hover:bg-wash transition-colors"
          >
            <span className="flex items-center gap-2 text-sm font-bold text-navy">
              CCTV access <ArrowUpRight size={13} className="text-safety" />
            </span>
            <span className="block mt-1 text-xs text-steel">Camera console — wsafe.si</span>
          </a>
          <a
            data-testid={`${testidPrefix}-mobile`}
            href="https://wsafe.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="block px-5 py-4 hover:bg-wash transition-colors"
          >
            <span className="flex items-center gap-2 text-sm font-bold text-navy">
              Mobile access <ArrowUpRight size={13} className="text-safety" />
            </span>
            <span className="block mt-1 text-xs text-steel">Mobile app — wsafe.ai</span>
          </a>
        </div>
      )}
    </div>
  );
};
